import { render, staticRenderFns } from "./login-recover.vue?vue&type=template&id=3795e7a2&scoped=true&"
import script from "./login-recover.vue?vue&type=script&lang=js&"
export * from "./login-recover.vue?vue&type=script&lang=js&"
import style0 from "./login-recover.vue?vue&type=style&index=0&id=3795e7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795e7a2",
  null
  
)

export default component.exports